import TagManager from "react-gtm-module";
import type { DeployEnv } from "../runtimeConfig.js";

const MEASUREMENT_ID: Partial<Record<DeployEnv, string>> = {
  dev: "G-4BH4SYZ8HK",
  stg: "G-W211Z025SH",
  partner: "G-LC92YMME50",
  prod: "G-BYYV0RQ089",
};

export function initGoogleTagManager(deployEnv: DeployEnv): void {
  if (deployEnv === "local") return;
  const gtmId = MEASUREMENT_ID[deployEnv];
  if (!gtmId) return;
  TagManager.initialize({
    gtmId,
    dataLayer: {
      js: new Date(),
    },
  });
}
